import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useLocale } from 'next-intl';
import { ShopIdsContext } from '@/components/ShopIds/ShopIdsProvider';
import { MP_SHOPS } from '@/utility/constants';
import { Locale } from '@/utility/locale';
import { ShopIds } from '@/utility/shopIds';

/** The shops of the current locale (`PageProviders`); only the marketplace shop without one. */
export const useShopIds = () => {
  const $ = _c(3);
  const shopIds = useContext(ShopIdsContext);
  const locale = useLocale() as Locale;
  let t0;
  if ($[0] !== locale || $[1] !== shopIds) {
    t0 = shopIds ?? {
      marketplaceShopId: MP_SHOPS[locale]?.shopId
    };
    $[0] = locale;
    $[1] = shopIds;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};